<template lang="html">
  <vs-card class="cardx">
    <div slot="header" style="padding:10px;height: 100%;width:100%;display:flex;align-items: center;">
      <h3>
        Customers
      </h3>
    </div>

    <div>
      <vs-table
        stripe
        search
        :sst="true"
        @search="handleSearch"
        :data="customers.customers">
        <template slot="thead">
          <vs-th sort-key="eco">
            Name
          </vs-th>
          <vs-th sort-key="Plate">
            Phone
          </vs-th>
          <vs-th sort-key="vehicle">
            Email
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(customer,index) in data"   >
            <vs-td>
              <router-link class="pointer" :to="{name: 'customers.detail', params: {id: customer.id}}"> {{customer.name}}</router-link>
            </vs-td>
            <vs-td>
              {{customer.phone}}
            </vs-td>
            <vs-td>
              {{customer.email}}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-3 mb-3">
         <span style="float:left;">
                  <vs-select
                    @input="filters.page=1"
                    class=""
                    label=""
                    v-model="filters.limit"
                    width="100px"
                    size="small"

                  >
                    <vs-select-item :key="'lim-'+index" :value="item.value" :text="item.text" v-for="(item,index) in limitOptions" />
                  </vs-select>
                </span>
        <pagination :last-page="customers.pagination.pages" v-model="filters.page" />
      </div>
    </div>
  </vs-card>
</template>


<script>
  import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
  import Orders from "../orders/data";
  import limitOptions from "../../constants/limit";

  export default {
    name : 'Customers',
    components: {
      orders: Orders
    },
    data (){
      return {
        page: 0,
        search : null,
        customer : null,
        filters : {},
        limitOptions
      }
    },
    computed : {
      ...mapState('customers',['customers','currentPage'])
    },
    watch : {
      filters : {
        deep: true,
        handler(newVal, oldVal){
          this.setRouteQuery();
          //if(!_.isEqual(newVal, oldVal))
          this.doSearch();
        }
      }
    },
    created(){
      this.filters = {
        limit: '20',
        ...this.$route.query,
        page: this.$route.query.page ? Number(this.$route.query.page) : 1,
      };
      this.doSearch = _.debounce(this.getItems,300);
    },
    methods: {
      ...mapGetters('users',['userCan']),
      ...mapActions('customers',['fetchCustomers']),
      ...mapMutations('customers',['SET_CUSTOMERS']),
      setRouteQuery(){
        let query = {...this.filters, page: `${this.filters.page}`};
        if(!_.isEqual(query, this.$route.query)){
          try{
            this.$router.push({query});
          }catch(error){

          }
        }
      },
      getItems(search){
        if(!this.userCan('users.read')){
          this.$vs.notify({
            color: 'danger',
            title: `Error`,
            text: 'You need permission to perform this action',
          });
          return;
        }

        this.$vs.loading({type:'point'});
        this.fetchCustomers(_.cloneDeep(this.filters))
          .then(data=>{
            this.$vs.loading.close();
          })
          .catch(error =>{
            this.$vs.loading.close();
            if(error.response.status === 404){
              this.SET_CUSTOMERS({
                customers : [],
                pagination : {
                  page: 1,
                  limit: 10,
                  total: 0,
                  pages: 0,
                  prev: null,
                  next: null
                }
              });
            }
          })
      },
      handleSearch(searching){
        this.filters = {...this.filters, page: 1, search: searching};
      },
      handleSelected(tr) {
        this.$router.push({name:'customers.detail', params: {id: tr.id}});
        /*
        this.customer = tr;
        this.filters =  {
          customer_id : this.customer.id,
        };
        //this.filters = [{ field: 'customer.id', op: '=', value: this.customer.id}]

         */
      },
    }

  }
</script>
